import { render } from "./two-col-sidebar.vue?vue&type=template&id=00e7c2d8"
import script from "./two-col-sidebar.vue?vue&type=script&lang=js"
export * from "./two-col-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__